<template>
  <div class="header-main">
    <div class="header-top-box">
      <div class="header-box1">
        <div class="box-top">
          <div class="box-top-left">
            <span class="box-top_big_title" @click="link">{{ modeTitle }}</span>
            <span class="address">鄞州区企业综合服务平台</span>
          </div>
          <div class="header_content_right">
            <div
              class="login_button mar_l_20"
              v-if="$store.state.isLogin"
              @click="loginOut"
            >
              登出
            </div>
            <div
              class="login_button mar_l_20"
              v-if="$store.state.isLogin"
              @click="toMyselfIndex"
            >
              用户中心
            </div>
            <!-- <div class="login_button mar_l_20" v-else @click="$toLogin">登录</div> -->
            <a-popover class="mar_l_20" v-else>
              <template slot="content">
                <div class="com_cur myself_choose" @click="$toLogin(0)">
                  个人登录
                </div>
                <div class="com_cur myself_choose" @click="$toLogin(1)">
                  法人登录
                </div>
                <!-- <div class="com_cur myself_choose" @click="toLogin">个人登录</div>
              <div class="com_cur myself_choose" @click="toLogin">法人登录</div> -->
              </template>
              <div class="login_button">用户登录</div>
            </a-popover>
            <div class="login_button mar_l_20" @click="toggleToolBar">
              无障碍
            </div>
            <div
              class="login_button mar_l_20"
              style="width: 120px"
              v-show="!$store.state.oldMode"
              @click="$store.commit('changeOldMode', true)"
            >
              进入老年模式
            </div>
            <div
              class="login_button mar_l_20"
              style="width: 120px"
              v-show="$store.state.oldMode"
              @click="$store.commit('changeOldMode', false)"
            >
              退出老年模式
            </div>
          </div>
        </div>
      </div>
      <div class="header-box2" v-html="navItem"></div>
    </div>
    <div class="header-content-box">
      <div class="header-content_title">
        <div class="header-content-left">
          <div class="title">{{ name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CmsHeader",
  props: {
    modeTitle: {
      type: String,
      require: false,
      default: "鄞商通",
    },
    name: {
      type: String,
      require: false,
      default: "政策服务",
    },
  },
  data() {
    return {
      navItem: "",
    };
  },
  created() {
    console.log(window.navItem);
    this.navItem = window.navItem;
  },
  methods: {
    link() {
      location.href = "https://qyfw.nbyz.gov.cn/index.html";
    },
    routerToName(name) {
      if (this.$route.name !== name) {
        this.$router.push({
          name: name,
        });
      }
    },
    toMyselfIndex() {
      if (this.$loginModal()) {
        if (location.href.indexOf("/myself/index") === -1) {
          this.$router.push({ path: "/myself/index" });
        }
      }
    },
    toLogin() {
      const lastUrl = location.href;
      document.cookie = "redirect" + "=" + lastUrl + "; path=" + "/";
      location.href =
        "https://qyfw.nbyz.gov.cn/yzqygx-web-fe1/index.html#/login";
    },
    loginOut() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "确定退出登录？",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        closable: false,
        onOk() {
          that.$loginOut();
        },
      });
    },
    toggleToolBar() {
      window.toggleToolBar();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-main {
  box-shadow: 0 2px 3px -1px rgba(0, 0, 0, 0.1);
  position: relative;
  /* color: #161a23; */
  color: #ffffff;
  width: 100%;
  /* height: 400px; */
  margin: 0 auto;
  /* background-image: url(https://qyfw.nbyz.gov.cn/cms_files/filemanager/2052681531/picture/202311/34c294f38d3e4a7eaf5fc781a3462d7f.png?t=1701154850094); */
  background-image: url(https://qyfw.nbyz.gov.cn/cms_files/filemanager/2052681531/picture/202311/610142d004594889bb6d712f9bcda9cb.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.header-top-box {
  border-bottom: 1px solid #ffffff;
  padding-bottom: 1px;
  height: 138px;
}

.header-box1 {
  margin: 0 auto;
  width: 1200px;
}

.header-box2 {
  margin: 0 auto;
  width: 1200px;
}

.box-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* height: 64px; */
  height: 80px;
}

.box-top-left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.box-top_big_title {
  font-family: AlimamaShuHeiTi-Bold;
  font-weight: 700;
  font-size: 32px;
  /* color: #007aea; */
  color: #ffffff;
  margin-right: 22px;
}

.box-top-left .address {
  font-family: AlibabaPuHuiTiR;
  font-size: 18px;
  /* color: #000000; */
  color: #ffffff;
}

.box-top_title {
  font-family: AlibabaPuHuiTiR;
  font-size: 20px;
  color: #007aea;
}

.box-top_line {
  font-size: 18px;
  color: #d8d8d8;
  margin: 0 20px;
}

.box-top_text {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  line-height: 24px;
}

.header_content_right {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  text-align: left;
  line-height: 32px;
  color: #000000;
  /* color: #FFFFFF; */
}

.mar_l_20 {
  margin-left: 20px;
}

.login_button {
  background: #ffaf00;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  width: auto;
  height: auto;
  padding: 0 0.875rem;
  margin-left: 0.875rem;
  background: #ffaf00;
  color: #fff;
  border-radius: 1rem;
}

.login_button:hover {
  color: #333333;
}

.margin_x_10 {
  margin: 0 10px;
}

.select_content >>> .ant-select-selection {
  border: 0 !important;
  box-shadow: 0 0 0 !important;
  height: 20px;
}

.select_content >>> .ant-select-selection__rendered {
  line-height: 20px;
}

.box-top_button {
  margin-left: 20px;
  width: 104px;
  height: 40px;
  background: #007aea;
  border: 1px solid #007aea;
  border-radius: 25px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
}

.box-top_button:hover,
.box-top_button:focus {
  background: #007aea;
}

::v-deep .box-bottom {
  /* font-size: 16px; */
  font-size: 18px;
  /* padding-top: 9px; */
}

::v-deep .nav_item {
  border-bottom: 3px solid transparent;
  color: inherit;
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
  /* height: 36px; */
  height: 41px;
  line-height: 18px;
  margin-right: 20px;
  transition: none;
}

::v-deep .nav_item:hover {
  /* font-weight: 700; */
  border-color: #ffffff;
}

::v-deep .nav_item:hover .nav__item__sub_panel {
  opacity: 1;
  transform: translate3d(-50%, 0, 0);
  visibility: visible;
}

::v-deep .nav_item-active {
  /* border-color: #0060f0; */
  border-color: #ffffff;
  font-weight: 700;
}

a {
  -webkit-text-decoration-skip: objects;
  background-color: transparent;
  color: #0060f0;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
}

::v-deep .nav__item__sub_panel {
  left: 50%;
  opacity: 0;
  padding-top: 8px;
  position: absolute;
  /* top: 111px; */
  top: 120px;
  transform: translate3d(-50%, -8px, 0);
  transition: all 0.3s;
  visibility: hidden;
  width: 1200px;
  z-index: 100;
}

::v-deep .nav__item__sub_menus {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px 0 rgba(22, 26, 35, 0.078);
  color: rgba(22, 26, 35, 0.88);
  display: flex;
  padding: 4px 0;
}

.nav__item__sub_menus__item {
  border-radius: 4px;
  color: inherit;
  display: block;
  font-size: 14px;
  font-weight: 700;
  height: 32px;
  line-height: 32px;
  text-align: center;
  transition: all 0.3s;
  width: 88px;
}

.nav__item__sub_menus__item:hover {
  background: #0060f0;
  color: #fff;
}

.nav__item__sub_menus__item-active {
  background: #0060f0;
  color: #fff;
}

.cur_poi {
  cursor: pointer;
}

.myself_choose {
  color: #333333;
}

.myself_choose:hover {
  /* color: #007aea; */
  color: #777;
}

.header-content-box {
  width: 1200px;
  margin: 0 auto;
  height: 262px;
}

.header-content_title {
  padding-top: 58px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header-content-left {
  color: #ffffff;
}

.header-content-left .title {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 20px;
}

.header-content-left .label {
  font-size: 22px;
  font-weight: 700;
  line-height: 2;
}

/* 当屏幕宽度小于或等于1200像素时，应用以下样式 */
@media (max-width: 1200px) {
  .header-main {
    width: 1200px;
    padding: 0 24px;
  }

  .header-box1 {
    width: 100%;
  }
}
</style>
